export default "__VITE_ASSET__CJAzS5Ne__"